export default class RatePlanForm {
  constructor(data = {}) {
    const sell = data.sell || {}
    const stay = data.stay || {}
    const rate = data.rate || {}

    this.name = data.name || null
    this.sellStartDate = sell.startDate || null
    this.sellEndDate = sell.endDate || null
    this.sellStartTime = sell.startTime || '00:00:00'
    this.sellEndTime = sell.endTime || '23:59:59'
    this.stayStartDate = stay.startDate || null
    this.stayEndDate = stay.endDate || null
    this.rateIncrease = rate.increase || true
    this.rateAmount = rate.amount || 0
    this.staticRate = data.staticRate || null
    this.breakfastIncluded = data.breakfastIncluded || false
    this.extrabedAllowed = data.extrabedAllowed || false
    this.roomTypes = data.roomTypes || []
    this.cancellationId = data.cancellationId || null
    this.sellLimitPerDay = data.sellLimitPerDay || null
    this.minimalNightStay = data.minimalNightStay || 1
    this.maximalNightStay = data.maximalNightStay || null
    this.minimalAdvancePurchase = data.minimalAdvancePurchase || null
    this.maximalAdvancePurchase = data.maximalAdvancePurchase || null
    this.benefits = data.benefits || []
  }

  static validator() {
    return {
      name: 'required|min:3',
      sellStartDate: 'required|date_format:yyyy-MM-dd',
      sellEndDate: 'required|date_format:yyyy-MM-dd',
      sellStartTime: {
        required: true,
        regex: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/,
      },
      sellEndTime: {
        required: true,
        regex: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/,
      },
      stayStartDate: 'required|date_format:yyyy-MM-dd',
      stayEndDate: 'required|date_format:yyyy-MM-dd',
      rateIncrease: 'required',
      rateAmount: 'required|min_value:0',
      staticRate: 'min_value:1',
      breakfastIncluded: 'required',
      extrabedAllowed: 'required',
      roomTypes: 'required',
      cancellationId: 'required',
      sellLimitPerDay: 'min_value:1',
      minimalNightStay: 'required|min_value:1',
      maximalNightStay: 'min_value:1',
      minimalAdvancePurchase: 'min_value:1',
      maximalAdvancePurchase: 'min_value:1',
      benefits: 'required',
    }
  }
}
